import React, { useEffect } from 'react';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import './index.scss';

const PrizeInfoCard = ({ prizeInfo, showAllPrize, receiveAward, onLotteryDraw }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { prizePic, prizeName, prizeType, prizeId } = prizeInfo;

  useEffect(() => {
    if (!showAllPrize) return;
    setIsOpen(true);
  }, [showAllPrize]);

  const handleLotteryDraw = () => {
    report(ATTA_REPORT.MULTIPLE_LOTTERY.LOTTERY_CARDFLIP_ANIMATION, {
      prizeType,
      prizeId,
    });
    onLotteryDraw();
    setIsOpen(true);
  };

  const handleReceive = () => {
    receiveAward(prizeInfo);
    report(ATTA_REPORT.MULTIPLE_LOTTERY.LOTTERY_REWARD_CLICK, {
      prizeType,
      prizeId,
    });
  };

  return (
    <div className="prize-Info-card" onClick={isOpen ? handleReceive : handleLotteryDraw}>
      <div className={`prize-Info-card__unopened ${isOpen ? 'unopned-flip' : ''}`}>
        <div className={'prize-Info-card__unopened__image'} />
      </div>
      <div className={`prize-Info-card__opened ${isOpen ? 'open-flip' : ''}`}>
        <img className="prize-Info-card__opened__image" src={prizePic} alt="[图片]" />
        <div className="prize-Info-card__opened__text">{prizeName}</div>
      </div>
    </div>
  );
};

export default PrizeInfoCard;
